import {Component, Input, OnInit, SimpleChanges, ViewChild,} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {icons} from 'src/app/ui/icons';

type Column = keyof any;

@Component({
    selector: 'app-recap-agrement-table-fo',
    templateUrl: './recap-agrement-table-fo.component.html',
    styleUrls: ['./recap-agrement-table-fo.component.css'],
})
export class RecapAgrementTableFOComponent implements OnInit {
    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @Input() data;

    displayedColumns: Column[] = ['bidCls', 'licenseCd'];
    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    labels: Partial<Record<Column, string>> = {
        licenseCd: 'Informations sur l\'agrément',
        bidCls: 'Num Lot/Article',
    };

    icons = icons;

    Ussine: any[] = [];

    constructor(
        private dialog: MatDialog,
        private formBuilder: FormBuilder,
        private appTranslateService: AppTranslateService
    ) {
    }

    ngOnInit(): void {
        this.loadDataSource(this.data);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const {data} = changes;
        if (data.currentValue !== data.previousValue) {
            this.loadDataSource(data.currentValue);
        }
    }

    loadDataSource(agrement) {
        this.dataSource.data = agrement;
    }
}
